/** 派工候选以公司库为主；无账号公司也可直接安排，账号仅用于明确通知和登录身份。
 * 老接口/未关联公司的账号仍兼容，同公司多账号标出用户名供经理明确选择，不能随机派给一个人。
 */
export function scheduleAssignees(options, zh) {
  const accounts = options.accounts || [], result = [], used = new Set();
  for (const company of options.companies || []) {
    const linked = accounts.filter((a) => a.companyId === company.id);
    const prefix = [company.name, company.tradeName || company.trade].filter(Boolean).join(" · ");
    if (!linked.length) result.push({ value: `company:${company.id}`, company,
      label: `${prefix} · ${company.disabledAccountCount ? (zh ? "账号已停用" : "Account disabled") : (zh ? "未开通账号" : "No account")}` });
    for (const account of linked) {
      used.add(account.username);
      result.push({ value: account.username, company, account, label: `${prefix} · ${account.nameZh || account.name || account.username}${linked.length > 1 ? ` (${account.username})` : ""}` });
    }
  }
  for (const account of accounts.filter((a) => !used.has(a.username))) result.push({ value: account.username, account,
    label: [account.company, account.nameZh || account.name || account.username].filter(Boolean).join(" · ") });
  return result;
}

/** 公司工种优先，未关联公司的旧账号使用自身设置；归一化由后端完成，前端不从名称猜测。 */
export function scheduleAssigneeTrade(options, username, companyId = "") {
  const account = (options.accounts || []).find((a) => a.username === username);
  const company = (options.companies || []).find((c) => c.id === (account?.companyId || companyId));
  const source = company || account;
  return { tradeKey: source?.tradeKey || "", tradeName: source?.tradeName || "" };
}
